<div class="kl-confirm-alert">
  <div class="kl-confirm-alert-dialog" [ngClass]="options.customClass">
    <h2 class="kl-confirm-alert-title">{{ options.title }}</h2>
    <div id="kl-confirm-alert-content" class="kl-confirm-alert-content">
      <label class="title" *ngIf="options.text">
        {{ options.text }}
      </label>
      <input
        *ngIf="options.confirm"
        [(ngModel)]="checkbox"
        type="checkbox"
        id="kl-confirm-checkbox"
        name="l-confirm-checkbox"
      />
      <label for="kl-confirm-checkbox" *ngIf="options.confirm">{{
        options.inputPlaceholder | translate
      }}</label>
      <div *ngIf="options.html" [innerHTML]="options.html | safeHtml"></div>
    </div>
    <div class="kl-confirm-alert-buttons-wrapper" style="display: block">
      <button
        type="button"
        tabindex="-1"
        id="confirmButton"
        (click)="onConfirm()"
        [ngClass]="options.confirmButtonClass"
        *ngIf="options.showConfirmButton"
      >
        {{ options.confirmButtonText }}
      </button>
      <button
        type="button"
        tabindex="-1"
        id="cancelButton"
        (click)="onCancel()"
        [ngClass]="options.cancelButtonClass"
        *ngIf="options.showCancelButton"
      >
        {{ options.cancelButtonText }}
      </button>
    </div>
  </div>
</div>
